export default function Footer() {
  return (
    <footer id="about" className="bg-[#1A1A1A] pt-8 md:pt-12 pb-8 md:pb-12 px-6 md:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col items-center justify-center gap-6 mb-8">
          <div className="flex items-center gap-4">
            <a 
              href="https://www.linkedin.com/in/okennaokpareke/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="w-12 h-12 rounded-full bg-[#2A2A2A] flex items-center justify-center hover:bg-[#FF6B4A] transition-all duration-300 cursor-pointer"
            >
              <i className="ri-linkedin-fill text-white text-xl"></i>
            </a>
            <a 
              href="mailto:ookpareke@gmail.com"
              className="w-12 h-12 rounded-full bg-[#2A2A2A] flex items-center justify-center hover:bg-[#FF6B4A] transition-all duration-300 cursor-pointer"
            >
              <i className="ri-mail-fill text-white text-xl"></i>
            </a>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-6 flex flex-col md:flex-row justify-between items-center gap-3">
          <p className="text-gray-500 text-xs md:text-sm text-center md:text-left">
            © 2026 Okenna Okpareke. All rights reserved.
          </p>
          <a 
            href="https://readdy.ai/?ref=logo" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-gray-500 hover:text-[#FF6B4A] transition-colors duration-300 text-xs md:text-sm cursor-pointer"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
